import styled, { keyframes } from 'styled-components';

const POPUP_WIDTH = 340;
const POPUP_Z_INDEX = 1000;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: ${POPUP_Z_INDEX};

  width: ${POPUP_WIDTH}px;
  max-width: calc(100vw - 32px);

  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);

  animation: ${slideIn} 0.35s ease-out;

  @media (max-width: ${({ theme }) => theme.media.tablet}px) {
    bottom: 16px;
    right: 16px;
    left: 16px;
    width: auto;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* proporção 16:9 */
  background-color: ${({ theme }) => theme.colors.blue_500};

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const Thumbnail = styled.div<{ image: string | null }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.blue_500};
  background-image: ${({ image }) => (image ? `url(${image})` : 'none')};
  background-size: cover;
  background-position: center;

  color: ${({ theme }) => theme.colors.white};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;

  width: 28px;
  height: 28px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0;
  border-radius: 50%;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.white};
  background-color: rgba(0, 0, 0, 0.55);
  transition: background-color 0.2s ease;

  &:hover,
  &:focus {
    background-color: rgba(0, 0, 0, 0.8);
    outline: none;
  }
`;

export const CtaButton = styled.a`
  display: block;
  width: 100%;
  padding: 14px 16px;

  text-align: center;
  font-weight: 600;
  font-size: 15px;
  text-decoration: none;

  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.lilac};
  transition: filter 0.2s ease;

  &:hover,
  &:focus {
    filter: brightness(0.92);
    color: ${({ theme }) => theme.colors.white};
    outline: none;
  }
`;
